import { render, staticRenderFns } from "./FeaturesSettings.vue?vue&type=template&id=7da13a2c&"
import script from "./FeaturesSettings.vue?vue&type=script&lang=js&"
export * from "./FeaturesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports